/**
 * Loading spinner.
 */
export default function Loading() {
  return (
    <div className="min-h-screen p-8 flex items-center justify-center">
      <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
    </div>
  );
}
